<template src= "./index.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import agTableComp from '@/optionData/agTableComp'
import swal from 'sweetalert2'
export default {
    name: 'upload',
  
    data () {
        return {
            ko : ko,
            dateType : 'created_at',
            startDate :null,
            endDate : null,
            page: {
                pageSize : 5,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
                context: {
                    componentParent: this
                },
                onGridReady: function (event) {
                },
                
                onRowClicked: (event)=>{
                    console.log('row',event.event.target.classList);
                    let classText = JSON.stringify(event.event.target.classList);
                    
                    console.log(classText);
                    if(classText.indexOf('vs-button') < 0 && classText.indexOf('button') < 0 ){
                        this.viewDetail(event)
                    }
                   
                },
                suppressRowClickSelection : false,
                onCellClicked : function(event){
                    console.log('isRowSelectable',event);
                    return true;
                },
                onSelectionChanged : function (event) {
                    console.log('onSelectionChanged',event);
                },
                frameworkComponents : agTableComp,
                getRowHeight:(params)=>{
                    console.log(params)
                    return 100;
                }
            },
            columnDefs: [
                {headerName: '로그등록일시', field: 'created_at', filter: false,width: 110, pinned: 'left',
                cellRenderer: (data) => {
                    return `<div class="cellCenter textCenter"><span>${this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')}</span></div>`
                }},
                {headerName: '계약사',  field: 'aggregator.name',  filter: false,width: 130, pinned: 'left',cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${data.value}</span></div>`
                }},
                {headerName: '상태',  field: 'state',  headerClass:'button',   filter: false,width: 180,
                cellRendererParams: {
                    clicked: (data) => {
                        if (data.state === 'validation_complete') {
                            this.tempExcel(data)
                        } else if (data.state === 'data_loading') {
                            this.showLoadingProgress(data)
                        }
                    }
                },
                cellRendererSelector: (data) => {
                    let dd='' ;
                    // temporary,
                    // data_loading,
                    // validation_processing,
                    // validation_incomplete,
                    // validation_complete,
                    // deposit_processing,
                    // deposit_complete,
                    // exchange_complete
                    if(data.value == 'validation_complete'){
                        let text = '검수완료(매칭로그다운로드)'

                        return {
                            component: 'btnSelect',
                            params: {
                                ...data.data,
                                title: text
                            }
                        }
                    }
                    if(data.value == 'data_loading'){
                        return {
                            component: 'btnSelect',
                            params: {
                                ...data.data,
                                title: '데이터 로딩중'
                            }
                        }
                    }
                    {
                        let text ={
                            'data_loading' : '<span class="dataUploadStatus" style="color:#797979">데이터 로딩중 </span>',
                            'validation_incomplete' :  '<span class="dataUploadStatus" style="color:#58a901">검수 가능 </span>',
                            'validation_processing' :  `<span class="dataUploadStatus" style="color:#58a901"><img class="n3VNCb" src="${require('../../../assets/images/loader.gif')}"  style="width: 20px; height: 20px; margin: 0px; display:inline-block; vertical-align:top;"> 검수 처리중 </span>`,
                            'validation_complete' :  '<span class="dataUploadStatus" style="color:#58a901" ><span>검수 완료 </span>',
                            'deposit_processing' : `<span class="dataUploadStatus" style="color:#009fd0"><img class="n3VNCb" src="${require('../../../assets/images/loader.gif')}"  style="width: 20px; height: 20px; margin: 0px; display:inline-block; vertical-align:top;">기준 화폐 환전 처리 중 </span>`,
                            'deposit_complete' : '<span class="dataUploadStatus" style="color:#009fd0">기준 화폐 환전 완료 </span>',
                            'exchange_complete' : '<span class="dataUploadStatus" style="color:#009fd0">2차환전 완료</span>',
                            'open_complete' : '<span class="dataUploadStatus">정산공개 완료</span>'
                        }
                        const img = img
                        let result =  `<div class="cellCenter"><span>${text[data.value]}</span></div>`
                        console.log(result)
                        dd = {
                            component: 'textRender',
                            params: {
                                ...data.data,
                                text: result
                            }
                        }
                    }
                    
                    return dd
                }},
                // cellRenderer: (data) => {
                //     let text ={
                //         'validation_incomplete' :  '<span class="dataUploadStatus" style="color:#58a901">검수 가능 </span>',
                //         'validation_processing' :  `<span class="dataUploadStatus" style="color:#58a901"><img class="n3VNCb" src="${require('../../../assets/images/loader.gif')}"  style="width: 20px; height: 20px; margin: 0px; display:inline-block; vertical-align:top;"> 검수 처리중 </span>`,
                //         'validation_complete' :  '<span class="dataUploadStatus" style="color:#58a901" ><span>검수 완료 </span>',
                //         'deposit_processing' : `<span class="dataUploadStatus" style="color:#009fd0"><img class="n3VNCb" src="${require('../../../assets/images/loader.gif')}"  style="width: 20px; height: 20px; margin: 0px; display:inline-block; vertical-align:top;">기준 화폐 환전 처리 중 </span>`,
                //         'deposit_complete' : '<span class="dataUploadStatus" style="color:#009fd0">기준 화폐 환전 완료 </span>',
                //         'exchange_complete' : '<span class="dataUploadStatus" style="color:#009fd0">2차환전 완료</span>',
                //         'open_complete' : '<span class="dataUploadStatus">정산공개 완료</span>'
                //     }
                //     const img = img 
                //      return `<div class="cellCenter"><span>
                     
                //      ${text[data.value]}
                //      </span></div>`
                // }},
                
                {headerName: '남은오류',      field: 'error_percentage',     filter: false,width: 100, cellRenderer: (data) => {
                    let text = ''
                    if(data.value){
                        text =  (Math.ceil(Number(data.value) * 100  ) / 100) + '%'
                    }else{
                        text =  '0%'
                    }
                    return `<div class="cellCenter"><span>${text}</span></div>`
                }},
                
                {headerName: '스토어정산금액(로그화폐)',    field: 'origin_amount',   filter: false,width: 200, cellRenderer: (data) => {
                    let text = ''
                    if(data.value){
                        text = this.numberFormat(data.value,'0') + ' '  + (!this.valCheck(data.data.origin_currency) ? data.data.origin_currency.toUpperCase() : 'null')
                    }else{
                        text = '계산불가'
                    }
                    return `<div class="cellCenter"><span>${text}</span></div>`

                    
                }},
                {headerName: '스토어정산금액(기준화폐)',  headerClass:'button',  field: 'state',   filter: false,width: 250,
                cellRendererParams: {
                    clicked: (data) => {
                        this.selectSales = data
                        this.transferKRW = null
                        this.openModal('deposit')
                    }
                },
                cellRendererSelector: (data) => {
                    let dd='' ;
                    // temporary,
                    // validation_processing,
                    // validation_incomplete,
                    // validation_complete,
                    // deposit_processing,
                    // deposit_complete,
                    // exchange_complete
                    if(
                    data.data.state != 'validation_processing'&&
                    data.data.state != 'validation_incomplete'&&
                    data.data.state != 'validation_complete' &&
                    data.data.state != 'deposit_processing' 
                    ){
                        let text = ''
                        if(data.data.amount){
                            text = this.numberFormat(data.data.amount,'0')  + ' KRW'
                        }else{
                            text = '0'
                        }
                        return { 
                            component: 'textRender',
                            params: {
                                ...data.data,
                                text: text
                            }
                        }
                    }else if(
                        data.data.state == 'validation_processing' || 
                        data.data.state == 'validation_incomplete'
                    ){
                        dd = {
                            component: 'textRender',
                            params: {
                                ...data.data,
                                text: '데이터 검수 필요'
                            }
                        }
                    }else if(data.data.state == 'deposit_processing'){
                        dd = {
                            component: 'textRender',
                            params: {
                                ...data.data,
                                text: '입금 처리중'
                            }
                        }
                    }else{
                        dd = {
                            component: 'btnSelect',
                            params: {
                                ...data.data,
                                title: '기준화폐등록'
                            }
                        }
                    }
                    
                    // dd = {
                    //         component: 'btnSelect',
                    //         params: {
                    //             ...data.data,
                    //             title: '기준 화폐 환전'
                    //         }
                    //     }
                    return dd
                }},
                
                { headerName : "정산화폐별금액/권리자공개일(정산일자)", headerClass: 'textCenter', field: 'origin_amount',   filter: false,width: 740, cellRendererSelector: (data) => {
                        let text = ''
                        if(data.value){
                            text = this.numberFormat(data.value) + ' '  
                        }else{
                            text = '0'
                        }
                        let salesAmountData = {
                            krw:{
                                amount : 0,
                                exchange_amount: 0,
                                open_state: "processing"
                            },
                            usd:{
                                amount : 0,
                                exchange_amount: 0,
                                
                                open_state: "processing"
                            },
                            eur:{
                                amount : 0,
                                exchange_amount: 0,
                                open_state: "processing"
                            }
                        };
                        let salesAmount = data.data.salesline_group_amount
                        for(var i in salesAmount){
                            salesAmountData[salesAmount[i].currency ] = salesAmount[i]
                            // if(salesAmount[i].currency == 'krw' ){
                            //     krwAmount =  salesAmount[i]
                            // }
                        }

                        
                        // amount: 81121.8483
                        // created_at: "2021-02-18T03:33:50.890Z"
                        // currency: "usd"
                        // exchange_amount: 63.8698204049
                        // exchange_rate: 1
                        // exchanged_at: null
                        // id: 1131
                        // open_state: "completed"
                        // opened_at: null
                        // salesline_group_id: 377
                        // updated_at: "2021-02-18T03:33:50.890Z"
                        return {
                            component: 'exchangeText',
                            params: {
                                ...data.data,
                                salesAmountData: salesAmountData
                            }
                        }
                    }
                },
                
                
                {headerName: '로그파일',    field: 'state',   filter: false,width: 150,
                cellRendererParams: {
                    clicked: (data) => {
                        // this.context.componentParent.selectUser(data)
                        //this.context.componentParent.closeModal('licensor')
                    }
                },
                cellRendererSelector: (data) => {
                    return { 
                        component: 'textRender',
                        params: {
                            ...data.data,
                                text: `<a href="${data.data.file? data.data.file.remote_path : 'none'}">로그파일 다운 </a>`
                        }
                    }
                }},
                {headerName: '삭제',    field: 'state',   filter: false,width: 150,
                cellRendererParams: {
                    clicked: (data) => {
                        console.log(this)
                        
                        this.deleteSales(data)
                        
                    }
                },
                cellRendererSelector: (data) => {
                    let dd='' ;
                    
                        dd = {
                            component: 'btnSelect',
                            params: {
                                ...data,
                                color:'danger'
                            }
                        }
                    
                    return dd
                }},
                {headerName: '로그 등록자',    field: 'user.admin_nickname',   filter: false,width: 150,cellRenderer: (data) => {
                    return `<div class="cellCenter"><span>${data.value}</span></div>`
                }}
            ],
            tableData:[
            ],       
            
            
            selectSales : {
                origin_currency : 'usd',
                origin_amount : 1000,
            },
            transferKRW : null,

            transferStep : 1,
            transferCurrency :null,
            transferDate : null,
            transferRate : null,
            checkList : [
                
            ],

            transferList :{
                pageSize : 5,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,
                data : [
                    {id:1,created_at :'222',aggregator_name :'dasdsa',amount:200000},
                    {id:2,created_at :'222',aggregator_name :'dasdsa',amount:200000},
                    {id:3,created_at :'222',aggregator_name :'dasdsa',amount:200000},
                    {id:3,created_at :'222',aggregator_name :'dasdsa',amount:200000},
                    {id:3,created_at :'222',aggregator_name :'dasdsa',amount:200000},
                ],
                gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
                    context: {
                        componentParent: this
                    },
                    onGridReady: function (event) {
                    },
                    
                    frameworkComponents :agTableComp,
                    tabToNextCell:false,
                    navigateToNextCell:false,
                    // getRowHeight:(params)=>{
                    //     console.log(params)
                    //     return 60;
                    // }
                }, 
                columnDefs: [
                    {headerName: '선택',  field: 'release_date',  filter: false,width: 100,
                    cellRenderer: 'transferCheckBox',
                    cellRendererParams: {
                        clicked: function(data) {
                            console.log(data);
                        //this.context.componentParent.closeModal('licensor')
                        }
                    },},
                    {headerName: '로그등록일시', field: 'salesline_group.created_at', filter: false,width: 150,height:80, 
                    cellRenderer: (data) => {
                        return `<div class="cellCenter textLeft"><span>${this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')}</span></div>`
                    }},
                    {headerName: '계약사',  field: 'salesline_group.aggregator.name',  filter: false,width: 330, 
                    cellRenderer: (data) => {
                        return `<div class="cellCenter"><span>${data.value}</span></div>`
                    }},
                    {headerName: '스토어정산금액(기준화폐)',    field: 'amount',   filter: false,width: 200, cellRenderer: (data) => {
                        let text = ''
                        if(data.value ){
                            text = this.numberFormat(data.value) + ' '  + 'KRW'
                        }else{
                            text = data.value + ' '  + 'KRW'
                        }
                        return `<div class="cellCenter"><span>${text}</span></div>`

                        
                    }},
                    //  {headerName: '스토어정산금액(정산화폐)',    field: 'amount',   filter: false,width: 200, cellRenderer: (data) => {
                    //     let text = ''
                    //     if(data.value ){
                    //         text = this.numberFormat(data.value) + ' '  + (!this.valCheck(data.data.currency) ? data.data.currency.toUpperCase() : 'null')
                    //     }else{
                    //         text = data.value + ' '  + (!this.valCheck(data.data.currency) ? data.data.currency.toUpperCase() : 'null')
                    //     }
                    //     return `<div class="cellCenter"><span>${text}</span></div>`

                        
                    // }},
                ],
            },
            checkListcolumnDefs: [
                {headerName: '선택',  field: 'release_date',  filter: false,width: 100,
                    cellRenderer: 'transferCheckBox',
                    cellRendererParams: {
                        clicked: function(data) {
                            console.log(data);
                        //this.context.componentParent.closeModal('licensor')
                        }
                    },
                },
                {headerName: '로그등록일',  field: 'salesline_group.created_at',  filter: false,width: 200,},
                {headerName: '계약사',  field: 'salesline_group.aggregator.name',  filter: false,width: 200,},
                {headerName: '스토어정산금액(로그화폐)',    field: 'exchange_amount',   filter: false,width: 200, cellRenderer: (data) => {
                    let text = ''
                    if(data.value){
                        text = this.numberFormat(data.value) + ' '  + (!this.valCheck(data.data.currency) ? data.data.origin_currency.toUpperCase() : 'null')
                    }else{
                        text = data.value + ' '  + (!this.valCheck(data.data.currency) ? data.data.origin_currency.toUpperCase() : 'null')
                    }
                    return `<div class="cellCenter"><span>${text}</span></div>`

                    
                }},
               
            ],


            openSalesStep : 1,
            openSalesCompany : null,
            openSalesCompanyOption : [],
            openSalesCurrency : null,
            openSalesCurrencyOption:[
                {value: '', label: '전체'},
                {value: 'krw', label: 'KRW'},
                {value: 'usd', label: 'USD'},
                {value: 'eur', label: 'EUR'},
            ],
            openSalesList :{
                pageSize : 5,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,
                data : [
                ],
                gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
                    context: {
                        componentParent: this
                    },
                    onGridReady: function (event) {
                    },
                    
                    frameworkComponents :agTableComp,
                    tabToNextCell:false,
                    navigateToNextCell:false,
                    // getRowHeight:(params)=>{
                    //     console.log(params)
                    //     return 60;
                    // }
                }, 
                columnDefs: [
                    {headerName: '선택',  field: 'release_date',  filter: false,width: 100,
                    cellRenderer: 'transferCheckBox',
                    cellRendererParams: {
                        clicked: function(data) {
                            console.log(data);
                        }
                    },},
                    {headerName: '로그등록일시', field: 'salesline_group.created_at', filter: false,width: 150,height:80, 
                    cellRenderer: (data) => {
                        return `<div class="cellCenter textCenter"><span>${this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')}</span></div>`
                    }},
                    {headerName: '계약사명',  field: 'salesline_group.aggregator.name',  filter: false,width: 200,},
                    {headerName: '스토어정산금액(로그화폐)',    field: 'exchange_amount',   filter: false,width: 200, cellRenderer: (data) => {
                    let text = ''
                    if(data.value){
                        text = this.numberFormat(data.value) + ' '  + (!this.valCheck(data.data.currency) ? data.data.currency.toUpperCase() : 'null')
                    }else{
                        text = data.value + ' '  + (!this.valCheck(data.data.currency) ? data.data.currency.toUpperCase() : 'null')
                    }
                    return `<div class="cellCenter"><span>${text}</span></div>`

                    
                }},
                ],
            },
           
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query['date_field']) this.dateType = this.$route.query['date_field'] 
        if(this.$route.query['date_start'] && this.$route.query['date_end'] ) {
            this.startDate = this.$route.query['date_start'] 
            this.endDate = this.$route.query['date_end'] 
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
            this.callList()
        })
    },
    computed: {
        transferTotal(){
            let amount  = 0;
            for(var i in this.checkList){
                if(this.checkList[i].amount){
                    amount += this.checkList[i].amount
                }
            }
            console.log('ddddd',amount)
            return amount
        }
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        },
        
        'transferList.currentPage'(val){
            this.amountListSearch()
        },
        'transferStep'(val){
            if(val== 2){
                console.log('로그 리스트 콜')
            }
        },
        'transferCurrency'(){
            this.amountListSearch()
        },
        'checkList'(){
            
        },
       'openSalesList.currentPage'(){
           this.openSalesListCall()
       },
    },
    methods: {
        
        callList(){
            const option = {
                sort: 'id',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
            }
            
            let query = {}

            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }  
            if(!this.valCheck(this.dateType) && !this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
                option['date_field'] = this.dateType
                option['date_start'] = this.startDate
                option['date_end'] = this.endDate
                
                query['date_start'] = this.startDate
                query['date_end'] = this.endDate
            }

            this.$router.replace({query: query}).catch((e)=>{});
            
            this.loadingShow()

            this.$store.dispatch('GET_SALESLINEGROUP', option)
            .then(result =>{
                this.loadingHide()
                this.tableData  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){
            this.page.currentPage = 1  // 초기화
            this.callList()
        },
        viewDetail(event){
            const blocked = ['exchange_complete', 'data_loading']
            if(!blocked.includes(event.data.state)){
                this.$router.push('/dataUpload/detail/'+event.data.id)
            }
        },
        showLoadingProgress(data){
            if(!data.id) return
            this.$store.dispatch('GET_SALESLINEGROUP_NOTICES', { id: data.id })
                .then(result => {
                    const { messages, done } = result
                    const lines = messages.length > 0
                        ? messages.map(m => `<div style="margin:2px 0;">${m}</div>`).join('')
                        : '<div style="color:#999">아직 메시지가 없습니다.</div>'
                    const statusLine = done
                        ? '<div style="color:#58a901;margin-top:8px;">✓ 완료</div>'
                        : '<div style="color:#999;margin-top:8px;">로딩 중...</div>'
                    swal.fire({
                        title: '데이터 로딩 진행 상황',
                        html: `<div style="text-align:left;font-family:monospace;font-size:12px;max-height:300px;overflow-y:auto;">${lines}</div>${statusLine}`,
                        confirmButtonText: '닫기'
                    })
                })
                .catch(() => { this.alert({ msg: '진행 상황을 가져올 수 없습니다.' }) })
        },
        deleteSales(data){
            console.log('zzz',data)
            let availableStatus = ['temporary', 'data_loading', 'validation_incomplete', 'validation_complete']
            if(availableStatus.indexOf(data.state)  < 0){
                this.alert({msg : '데이터 로딩중, 검수가능, 검수완료 상태만 삭제가 가능합니다.'})
                return false
            }
            this.confirm({
                title : '로그 삭제',
                msg : `
                선택하신 로그를 삭제하시겠습니까?<br/><br/>
                <div class="textLeft">
                
                로그 삭제 후 복구가 불가능합니다.<br/>
                
                </div>
                `,
                action : ()=>{
                    let payload = {
                        id : data.id
                    }
                    
                    this.loadingShow()
                    this.$store.dispatch("DELETE_SALESLINEGROUP", payload)
                    .then(result =>{
                        
                        this.callList()
                        this.loadingHide();
                        this.alert({msg: '삭제가 완료되었습니다.'});
                    }).catch(error =>{
                        this.loadingHide();
                        switch(error.response.data.code) {
                            default:
                            this.alert({msg:error})
                            break;
                    }
                    })
                }
            })
        },
        // 스토어 기준화폐 환전 ( 1차 )
        postDeposit(){
            console.log(this.transferKRW)
            if(this.valCheck(this.transferKRW)){
                this.alert({msg:'스토어정산금액(기준화폐)을 입력해주세요.'});
                return false;
            }
            
            this.transferKRW = String(this.transferKRW).replace(/,/gi, ""); 
            if(!Number(this.transferKRW)){
                this.alert({msg:'스토어정산금액(기준화폐)을 확인해주세요.'});
                return false;
            }
            this.confirm({
                title : '검수내역 반영',
                msg : `
                검수내역을 반영하시겠습니까?<br/><br/>
                <div class="textLeft">
                데이터 검수 및  기준화폐  환전(입금확인) 내역을 반영합니다.<br/>
                검수내역 반영 후에 권리자 정산화폐 환전 등록이 가능하며, 로그의 삭제가 불가능합니다.<br/>
                검수내역 반영이 권리자에게 공개되는 것은 아닙니다.<br/>
                권리자에게 공개는 정산화폐 환전 완료 후 가능합니다.<br/>
                </div>
                `,
                action : ()=>{
                    let payload = {
                        id : `${this.selectSales.id}`,
                        params : {
                            amount: this.transferKRW
                        }
                    }
                    this.closeModal('deposit')
                    this.loadingShow();

                    // await new Promise((resolve, reject) => setTimeout(resolve, 500))
                    this.$store.dispatch("PUT_DEPOSIT_COMPLETE", payload)
                    .then(result =>{
                        
                        setTimeout(() => {
                            this.loadingHide();
                            swal.fire({
                            type: 'success',
                            html: `요청이 완료 되었습니다.
                                    <br>작업이 완료되면 다운로드 링크가
                                    <br>알림(slack)으로 전송 될 것입니다.`,
                            })
                            this.callList()
                        }, 5000);
                        
                    }).catch(error =>{
                        this.loadingHide();
                        swal.close()
                        switch(error.response.data.code) {
                            default:
                            this.alert({msg:error.response.data.message})
                            break;
                    }
                    })
                }
            })
            
        },
        //권리자 정산화폐 환전
        openTransfer(){
            this.transferStep = 1
            this.transferCurrency = null
            this.transferDate = null
            this.transferRate = null
            this.checkList = []
            //this.transferList.data = []
            this.openModal('transfer')
        },
        //2차환전
        postTransfer(data){
            if(this.openSalesList.length == 0){
                this.alert({msg:'선택된 로그가 없습니다.'})
                return false
            }
            if(this.valCheck(this.transferRate)){
                this.alert({msg:'환전환율을 입력해주세요.'})
                return false
            }
            if(this.valCheck(this.transferDate)){
                this.alert({msg:'환전일자를 입력해주세요.'})
                return false
            }

            if(this.parse(this.transferRate) == NaN){
                this.alert({msg:'환율을 확인해주세요!'})
                return false
            }
            
            let payload ={
                "currency": this.transferCurrency.toLowerCase(),
                "exchange_date": this.transferDate,
                "exchange_rate": this.onlyNumber(this.transferRate),
                "slga": []
            }
            for( var i in this.checkList){
                payload.slga.push(this.checkList[i].id)
            }
            console.log(payload)
            
            //return false            
            this.loadingShow()

            this.$store.dispatch('SALES_EXCHANGE', payload)
            .then(result =>{
                setTimeout(() => {
                    
                    this.alert({msg:this.checkList.length + '건의 환전 신청이 완료되었습니다. \ 진행 결과는 Slack으로 알려드리겠습니다.'})
                    this.checkList =  []
                    this.closeModal('transfer')
                    this.callList()    
                }, 1000);
                
                
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        amountListSearch(){
            let payload ={
                params:{
                    sort : 'created_at',
                    sortorder : 'desc',
                    open_state: "closed",
                    limit: this.transferList.pageSize,
                    page: this.transferList.currentPage-1,
                    limit: this.transferList.pageSize,
                    currency : this.transferCurrency.toLowerCase()
                }
            }
            this.loadingShow()
            this.$store.dispatch('SALES_AMOUNT_LIST', payload)
            .then(result =>{
                this.loadingHide()
                this.transferList.data  = result.items // 권리자 목록
                
                //페이지 수
                const remainder = parseInt(result.filtered % this.transferList.pageSize) > 0 ? 1: 0
                console.log(remainder)
                this.transferList.totalPage = parseInt(result.filtered / this.transferList.pageSize) + remainder
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
            
        },
       
     
        companyCallList(){
            this.loadingShow()
            this.$store.dispatch('GET_AGGREGATOR')
            .then(result =>{
                this.loadingHide()
                this.openSalesCompanyOption  = result // 권리자 목록
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        openSales(){
            //this.openSalesList.data = []
            this.checkList = []
            this.openSalesCurrency = null;
            this.openSalesCompany = null;
            this.openSalesList.currentPage = 1 ;
            this.openSalesStep = 1
            
            this.companyCall();
            this.openSalesListCall();
            this.openModal('openSales');
        },
        companyCall(){
            this.loadingShow()
            this.$store.dispatch('GET_AGGREGATOR')
            .then(result =>{
                this.loadingHide()
                this.openSalesCompanyOption = result // 권리자 목록
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        openSalesListCall(){
             let payload ={
                params:{
                    sort : 'id',
                    sortorder : 'desc',
                    open_state: "exchange_complete",
                    limit: this.openSalesList.pageSize,
                    page: this.openSalesList.currentPage-1,
                    limit: this.openSalesList.pageSize,
                    
                }
            }
            
            if(!this.valCheck(this.openSalesCurrency)){
                payload.params['currency'] = this.openSalesCurrency
            }
            if(!this.valCheck(this.openSalesCompany)){
                payload.params['_aggregator_id'] = this.openSalesCompany
            }
            
            this.loadingShow()
            this.$store.dispatch('SALES_AMOUNT_LIST', payload)
            .then(result =>{
                
                this.loadingHide()
                this.openSalesList.data  = result.items // 권리자 목록
                
                //페이지 수
                const remainder = parseInt(result.filtered % this.openSalesList.pageSize) > 0? 1: 0
                this.openSalesList.totalPage = parseInt(result.filtered/this.openSalesList.pageSize) + remainder
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        postOpenSales(){
            if(this.checkList.length == 0){
                this.alert({msg:'선택된 로그가 없습니다.'})
                return false
            }
            let payload ={
                "slga": []
            }
            for( var i in this.checkList){
                payload.slga.push(this.checkList[i].id)
            }
            //return false            
            this.loadingShow()

            this.$store.dispatch('SALES_OPEN', payload)
            .then(result =>{
                setTimeout(() => {
                   
                    this.alert({msg:this.checkList.length + '건의 공개 신청이 완료되었습니다. \ 진행 결과는 Slack으로 알려드리겠습니다.'})
                     this.checkList =  []
                    this.closeModal('openSales')
                    this.callList()
                },1000)
                
                
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        console.log(error.response);
                        this.alert({msg : error.response.data.message +'<br/>'+JSON.stringify(error.response.data.data), })
                    break;
                }
            })
        },
        krwSet(){
            this.transferKRW = this.selectSales.origin_amount
            this.$refs.transferKRW.focus()
            this.$refs.transferKRW.value = this.selectSales.origin_amount
            
        },
        tempExcel(data){
            if(!data.id){
                this.alert({msg : '잘못된 접근입니다'})
                return false
            }
            let payload = {
                id : data.id
            }
            this.$store.dispatch('GET_SALESLINE_TEMP_EXCEL',payload)
            .then(result =>{
                this.loadingHide()
                this.alert({msg : `요청이 완료되었습니다. \ 파일 준비 완료시 본인 Slack으로 Excel 파일 다운로드 링크가 발송됩니다.`})
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        }
        
    }
}
</script>

<style scoped>

</style>
